"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.routesPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var routesPropType = _propTypes.default.arrayOf(_propTypes.default.exact({
  type: _propTypes.default.string,
  key: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  pathWithParams: _propTypes.default.string,
  path: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  component: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func, _propTypes.default.object]),
  icon: _propTypes.default.string,
  separator: _propTypes.default.shape({
    above: _propTypes.default.bool,
    below: _propTypes.default.bool
  }),
  link: _propTypes.default.string,
  routes: _propTypes.default.array,
  isSelected: _propTypes.default.bool,
  isOpen: _propTypes.default.bool,
  onClick: _propTypes.default.func
}));

exports.routesPropType = routesPropType;
var _default = routesPropType;
exports.default = _default;